<div class="container">
  <div class="card box">
    <div class="grid p-fluid">
      <div class="col-12 lg:col-12 md:col-12">
        <span class="p-text-bold" style="font-size: 4rem; letter-spacing: .7rem;">\(o_o)/</span>
      </div>
      <div class="col-12 lg:col-12 md:col-12 mb-4">
        <span class="p-text-bold" style="font-size: 2rem;">PÁGINA NÃO ENCONTRADA</span>
      </div>
      <div class="col-12 lg:col-12 md:col-12">
        <button style="width: 100%;" icon="pi pi-home" type="button" pButton label="Voltar ao início"
          [routerLink]="['/']"></button>
      </div>
    </div>
  </div>
</div>